<template>
    <nav>
        <div class="row">
            <div class="col-sm-4">
                <label>Station Group</label>
                <select class="form-select form-select-sm" v-model="selectedStationGroupId" >
                    <option :value="null">All Groups</option>
                    <option v-for="stationGroup in StationGroup" :value="stationGroup.id" :key="stationGroup.id">{{ stationGroup.name }}</option>
                </select>
            </div>
            <div class="col-sm-4">
                <label>Station</label>
                <select class="form-select form-select-sm" v-model="selectedStationId" @change="stationChanged">
                    <option :value="null">All Stations</option>
                    <option v-for="station in filteredStations" :value="station.id" :key="station.id">{{ station.name }}</option>
                </select>
            </div>
            <div class="col-sm-4">
                <label>Shift (with station)</label>
                <select class="form-select form-select-sm" v-model="selectedStationShiftId">
                    <option :value="null">All Shifts</option>
                    <option v-for="ss in filteredStationShifts" :value="ss.id" :key="ss.id">{{ ss.name }}</option>
                </select>
            </div>
        </div>
    </nav>
</template>

<script>
    import StationService from '../../../services/StationsService';
    import StationShiftService from '../../../services/StationShiftService';

    export default {
        name: "ReportFiltersForShiftWiseReport",
        data: () => ({
            StationGroup:[],
            allStations:[],
            allStationShifts: []
        }),
        computed: {
            // F-03: station group backed by Vuex; selecting a group resets station
            // and shift to "All" so the report shows the whole group's aggregate.
            selectedStationGroupId: {
                get() {
                    return this.$store.state.reportPageFilters.selectedStationGroupId;
                },
                set(stationGroupId) {
                    this.$store.dispatch('selectedStationGroupId', stationGroupId);
                    this.$store.dispatch('selectedStationId', null);
                    this.$store.dispatch('selectedStationShiftId', null);
                }
            },
            selectedStationId: {
                get() {
                    let selectedStationShiftIdCheck = this.$store.state.reportPageFilters.selectedStationId;
                    return  selectedStationShiftIdCheck === null ? null : selectedStationShiftIdCheck;
                },
                set(stationShiftId) {
                    this.$store.dispatch('selectedStationId', stationShiftId);
                }
            },
            selectedStationShiftId: {
                get() {
                    let selectedStationShiftIdCheck = this.$store.state.reportPageFilters.selectedStationShiftId;
                    return  selectedStationShiftIdCheck === null ? null : selectedStationShiftIdCheck;
                },
                set(stationShiftId) {
                    this.$store.dispatch('selectedStationShiftId', stationShiftId);
                }
            },

            filteredStations() {
                let vm = this;
                if(this.selectedStationGroupId == null || this.selectedStationGroupId == 0) {
                    return vm.allStations;
                }
                return vm.allStations.filter(function (station) {
                    return station.station_group.id === vm.selectedStationGroupId;
                });
            },
            filteredStationShifts() {
                let vm = this;
                let stationShifts = this.allStationShifts.map(function(ss){
                    ss.name = `${ss.shift_name} (Station: ${ss.station_name} )`;
                    return ss;
                });

                if(this.selectedStationGroupId != null && this.selectedStationGroupId != 0) {
                    stationShifts = stationShifts.filter(function(ss){
                        return ss.station_group_id === vm.selectedStationGroupId;
                    });
                } else if(this.selectedStationId != null && this.selectedStationId != 0) {
                    stationShifts = stationShifts.filter(function(ss){
                        return ss.station_id === vm.selectedStationId;
                    });
                }

                // Sort the dropdown sensibly: group a station's shifts together
                // (by station name), then by shift name. Without this the options
                // come back in raw insertion order, interleaving stations.
                return stationShifts.slice().sort(function(a, b){
                    const byStation = (a.station_name || '').localeCompare(b.station_name || '');
                    return byStation !== 0 ? byStation : (a.shift_name || '').localeCompare(b.shift_name || '');
                });
            },
            selectedStation(){
                const vm = this;
                return vm.allStations.find(station => station.id === vm.selectedStationId);
            },
            selectedStationShift(){
                const vm = this;
                return vm.allStationShifts.find(so => so.id === vm.selectedStationShiftId);
            }
        },
        // F-03: auto-select-first watchers removed; filters default to "All".
        methods: {
            stationChanged() {
                // Reflect the chosen station's group in the group dropdown without
                // wiping the station selection (so dispatch the action directly
                // rather than going through the resetting computed setter).
                if(this.selectedStation && this.selectedStation.station_group) {
                    this.$store.dispatch('selectedStationGroupId', this.selectedStation.station_group.id);
                }
            },
            // stationShiftSelected() {
            //     if(this.selectedStationShift){
            //         this.selectedStationId = this.selectedStationShift.station_id;
            //         this.selectedStationGroupId = this.selectedStationShift.station_group_id;
            //     }
            //     this.$emit('stationShiftSelected', {
            //         'stationShiftId': this.selectedStationShiftId,
            //         'stationShift': this.selectedStationShift
            //     });
            // },
        },
        mounted() {
            StationService.fetchAllGroups( response => {
                this.StationGroup = response;
            });
            StationService.fetchAll([], response => {
                this.allStations = response;
            });
            StationShiftService.allStationShiftsForReportDropdown(response => {
                this.allStationShifts = response;
            });

        }
    }
</script>
